import React from 'react'

import "./table.scss";
import { useEffect as uEffect, useState as uState } from "react";
import {useParams as uParams} from 'react-router-dom'

export default function singleUserTrans() {

    const {id} =uParams()

    const [userOrder, setUserOrder] = uState('');
    uEffect(() => {
        async function fetchData() {
            const response = await fetch('http://localhost:8000/users/userOrders',
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body:JSON.stringify({userId:id})
                }
            );
            const data = await response.json();
            setUserOrder(data);
        }
        fetchData();
    }, [])

    const formatDate = (date) => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(date).toLocaleString("en-US", options);
    }

    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Product Id</th>
                        <th scope="col">Product Type</th>
                        <th scope="col">Product</th>
                        <th scope="col">Date</th>
                        <th scope="col">Amount</th>
                    </tr>
                </thead>
                {userOrder && Array(userOrder).map((order, index) => (
                    <tbody key={index}>
                        <React.Fragment >
                            {order.order_data.slice().reverse().map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item[1].id}</td>
                                    <td>{item[1].productType}</td>
                                    <td className='cellWrapper'><img className='image' src={`http://localhost:8000/public/images/${item[1].productImage}`} alt="" />{item[1].productTitle}</td>
                                    <td>{formatDate(item[0].Order_date)}</td>
                                    <td>₹{item[1].productAmount}</td>
                                </tr>
                            ))}
                        </React.Fragment>
                    </tbody>
                    ))}

            </table>
        </>
    )
}

